import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { BrowserRouter } from 'react-router-dom'
import MsalProviderCustom from './Components/MsalProviderCustom'
import { ToastContainer } from 'react-toastify'
// Side-effect import: applies the global axios request timeout before any call.
import './services/httpDefaults'
import { AuthProvider } from './contexts/AuthContext'
import 'react-toastify/dist/ReactToastify.css'

/**
 * MSAL's redirectUri is an app route (/redirect), so a sign-in popup loads this
 * whole app inside itself. When it did, the app's own MsalProvider processed the
 * response and cleared the hash before the window that opened the popup could read
 * it, and loginPopup failed with hash_empty_error.
 *
 * MSAL names the popup window it opens 'msal.<something>', so a popup can tell what
 * it is: leave the hash alone and let the opener finish signing in. The redirect
 * flow is unaffected - that lands in the main window, which has no such name.
 */
const isMsalPopup = typeof window !== 'undefined' && window.name.startsWith('msal.')

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

if (!isMsalPopup) {
  root.render(
    <>
      <BrowserRouter>
        <AuthProvider>
          <MsalProviderCustom>
            <App />
            <ToastContainer />
          </MsalProviderCustom>
        </AuthProvider>
      </BrowserRouter>
    </>,
  )
}

reportWebVitals()
